import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tooltip,
  Typography
} from '@material-ui/core'
import {
  TextValidator,
  ValidatorForm
} from 'react-material-ui-form-validator'
import { compraAction } from '../../_actions'
import EmailIcon from '@material-ui/icons/Email';
import HelpIcon from '@material-ui/icons/Help'
import { StickyContainer, Sticky } from 'react-sticky';
import { AccessControl } from '../../components/Utils/AccessControl'
import moment from 'moment'

const styles = {
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

export const CompraEmailModal = ({ modal, toggle }) => {
  const dispatch = useDispatch()

  // Obter o primeiro dia do mês passado
  const primeiroDiaMesPassado = new Date();
  primeiroDiaMesPassado.setMonth(primeiroDiaMesPassado.getMonth() - 1);
  primeiroDiaMesPassado.setDate(1);
  const primeiroDiaFormatado = primeiroDiaMesPassado.toISOString().split('T')[0];

  // Obter o último dia do mês passado
  const ultimoDiaMesPassado = new Date();
  ultimoDiaMesPassado.setDate(0); // Dia 0 do mês atual = último dia do mês anterior
  const ultimoDiaFormatado = ultimoDiaMesPassado.toISOString().split('T')[0];

  const [dataInicio, setDataInicio] = useState(primeiroDiaFormatado)
  const [dataTermino, setDataTermino] = useState(ultimoDiaFormatado)
  const [email, setEmail] = useState("")
  const [isSending, setIsSending] = useState(false)

  const { idLoja } = useSelector(
    (state) => state.usuarioLoja
  )

  const handleChangeDataInicio = (e) => {
    setDataInicio(e.target.value)
  }

  const handleChangeDataTermino = (e) => {
    setDataTermino(e.target.value)
  }

  const handleChangeEmail = (e) => {
    setEmail(e.target.value)
  }

  const isLoadingCompraModal = useSelector(
    (state) => state.compra.isLoading
  )

  const handleSubmit = (event) => {

    let payload = {
      IdLoja: idLoja,
      DataInicio: moment(dataInicio).format("YYYY-MM-DD"),
      DataFim: moment(dataTermino).format("YYYY-MM-DD"),
      Email: email ?? ''
    };

    setIsSending(true)

    dispatch(compraAction.sendCompraEmail(payload));
  };

  //useEffect(() => {
  //  if (isLoadingCompraModal) {
  //    setTimeout(() => {
  //      setIsSending(false)
  //    }, (15000));
  //  }
  //}, [isLoadingCompraModal]);

  return (
    <div>
      <Dialog
        open={modal}
        onClose={toggle}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle>
          <Grid alignItems="flex-end" container justifyContent="space-between" spacing={3}>
            <Grid item>
              <Typography style={{ fontSize: "16px", fontWeight: 'bold', textAlign: "left", marginRight: 5 }}>
                ENVIAR ARQUIVOS XML/PDF DAS COMPRAS POR E-MAIL
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <ValidatorForm
          id="formCompraEmail"
          onSubmit={(event) => handleSubmit(event)}
        >
          <DialogContent sx={styles}>
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} xl={12} xs={12}>
              
                  <Grid container spacing={2}>
                    <Grid item lg={6} md={6} xl={6} xs={12}>
                      <TextValidator
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        id="dataInicio"
                        label="Data Inicial *"
                        margin="normal"
                        type="date"
                        value={dataInicio}
                        onChange={handleChangeDataInicio}
                        validators={['required']}
                        errorMessages={['Campo obrigatório!']}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item lg={6} md={6} xl={6} xs={12}>
                      <TextValidator
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        id="dataTermino"
                        label="Data Término *"
                        margin="normal"
                        type="date"
                        value={dataTermino}
                        onChange={handleChangeDataTermino}
                        validators={['required']}
                        errorMessages={['Campo obrigatório!']}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                      <TextValidator
                        fullWidth
                        id="email"
                        label="E-mail de destino *"
                        margin="normal"
                        type="email"
                        value={email}
                        onChange={handleChangeEmail}
                        validators={['required']}
                        errorMessages={['Campo obrigatório!']}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StickyContainer>
              <Sticky relative={false} isSticky={true}>
                {({ style }) => (
                  <Grid>
                    <AccessControl
                      rule={'compras.create'} //permissão necessária para acessar conteúdo
                      yes={() => (
                        <Grid item lg={12} md={12} xl={12} xs={12} style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'row',
                          paddingRight: 0,
                          marginRight: 0
                        }}>
                          <Button
                            color="default"
                            onClick={toggle}
                            variant="contained"
                            style={{
                              justifyContent: 'right'
                            }}
                          >
                            Cancelar
                          </Button>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            style={{
                              justifyContent: 'right',
                              marginRight: 0
                            }}
                            disabled={isLoadingCompraModal && isSending}
                            startIcon={<EmailIcon />}
                            endIcon={(isLoadingCompraModal && isSending) && <CircularProgress size={24} />}
                          >
                            {isLoadingCompraModal && isSending ? 'Enviando...' : 'Enviar'}
                          </Button>
                        </Grid>
                      )}
                    />
                  </Grid>
                )}
              </Sticky>
            </StickyContainer>
          </DialogActions>
        </ValidatorForm>
      </Dialog>
    </div>
  );
}
